import React from "react"
import { Provider } from "react-redux"
import { PersistGate } from "redux-persist/integration/react"
import { store, persistor } from "./src/reduxfolder/store"
import { ThemeProvider } from "theme-ui"
import theme from "./src/theme"
import setupLocatorUI from "@locator/runtime"

if (process.env.NODE_ENV === "development") {
  setupLocatorUI()
}

const WrapRootElement = ({ element }: { element: React.ReactNode }) => {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ThemeProvider theme={theme}>
          {element}
        </ThemeProvider>
      </PersistGate>
    </Provider>
  )
}

export default WrapRootElement
